import { IWebsiteBuilderSectionBackground } from "pages/secure/facility/websiteBuilder/editor/nodes/section/websiteBuilderSection";
import { IWebsiteBuilderEditorHistoryActionBase, IWebsiteBuilderHistorySnapshot, WebsiteBuilderEditorActionType } from "../../websiteBuilderEditorAction";
import { cloneDeep } from "lodash";
import { IWebsiteBuilderRoot } from "pages/secure/facility/websiteBuilder/editor/nodes/root/websiteBuilderRoot";
import { sectionTraversal, TWebsiteBuilderSectionTraversalUpdate } from "../../actionHelpers/sectionTraversal";
import { IWebsiteBuilderHeader } from "pages/secure/facility/websiteBuilder/editor/nodes/section/websiteBuilderHeader";
import { IWebsiteBuilderFooter } from "pages/secure/facility/websiteBuilder/editor/nodes/section/websiteBuilderFooter";

export interface IUpdateSectionBackgroundActionPayload {
  id: string;
  prevSectionBackground: IWebsiteBuilderSectionBackground;
  nextSectionBackground: IWebsiteBuilderSectionBackground;
}

export interface IUpdateSectionBackgroundAction extends IWebsiteBuilderEditorHistoryActionBase {
  type: typeof WebsiteBuilderEditorActionType.UPDATE_SECTION_BACKGROUND;
  payload: IUpdateSectionBackgroundActionPayload;
}

export function getUpdateSectionBackgroundInverseAction(
  action: IUpdateSectionBackgroundAction,
): IUpdateSectionBackgroundAction {
  const { id, nextSectionBackground, prevSectionBackground } = action.payload;

  return {
    type: WebsiteBuilderEditorActionType.UPDATE_SECTION_BACKGROUND,
    pageId: action.pageId,
    device: action.device,
    scrollNodeId: action.scrollNodeId,
    payload: {
      id,
      prevSectionBackground: cloneDeep(nextSectionBackground),
      nextSectionBackground: cloneDeep(prevSectionBackground),
    },
  };
}

export function applyUpdateSectionBackgroundChange(
  header: IWebsiteBuilderHeader,
  root: IWebsiteBuilderRoot,
  footer: IWebsiteBuilderFooter,
  action: IUpdateSectionBackgroundAction,
): IWebsiteBuilderHistorySnapshot {
  const { id, nextSectionBackground } = action.payload;

  const update: TWebsiteBuilderSectionTraversalUpdate = prev => {
    return {
      ...prev,
      background: nextSectionBackground,
    };
  };

  return (
    sectionTraversal(
      header,
      root,
      footer,
      id,
      update,
    )
  );
}